import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BaseResponse,
  BaseResponseSingle,
  CategoryRelationshipResponse,
  CategoryResponse,
  SecondSubCategoryResponse,
  SubcategoryResponse,
} from "../../typings/interfaces";
import {
  GET_ALL_ALTERATION_PRICE,
  GET_ALL_CATEGORIES,
  GET_ALL_PRICINGS,
  GET_ALL_SECOND_SUB_CATEGORIES,
  GET_ALL_SUB_CATEGORIES,
  GET_ALTERATION_SUB_CATEGORIES,
  GET_CATEGORY_RELATIONSHIP,
  GET_FABRIC_TYPES,
  GET_CATEGORY_MATERIAL_RELATIONSHIP,
  GET_SUB_CATEGORY_MATERIAL_RELATIONSHIP,
  UPLOAD_PRICE_LIST,
  GET_PRICE_LIST,
  REORDER_CATEGORIES,
  REORDER_SUB_CATEGORIES,
  CREATE_SUBCATEGORY_WITH_IMAGE,
  CREATE_MATERIAL,
  REORDER_MATERIALS,
  UPDATE_MATERIAL,
  UPDATE_CATEGORY,
  UPDATE_SUBCATEGORY,
  CREATE_SECOND_SUBCATEGORY,
  REORDER_SECOND_SUBCATEGORIES,
  UPDATE_SECOND_SUBCATEGORY,
  UPSERT_PRICE,
  DELETE_CATEGORY,
  DELETE_SUBCATEGORY,
  DELETE_MATERIAL,
  DELETE_SECOND_SUBCATEGORY,
} from "../../configs";
import { PricingResponse } from "../../typings/interfaces/responses/pricing-response";
import { AlterationSubCategoryResponse } from "../../typings/interfaces/responses/alteration-sub-category-response";
import { AlterationPriceResponse } from "../../typings/interfaces/responses/alteration-price-response";
import { FabricTypeResponse } from "../../typings/interfaces/responses/fabricTypeResponse";
import { CategoryMaterialRelationshipResponse } from "../../typings/interfaces/responses/category-material-relationship";
import { SubCategoryMaterialRelationshipResponse } from "../../typings/interfaces/responses/sub-category-material-relationship";
import { IPriceResponseBody } from "../../typings/interfaces/responses/price-list-response";

export const getCategoryAction = createAsyncThunk(
  "pricing/category",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<CategoryResponse>>(
        GET_ALL_CATEGORIES
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getSubCategoryAction = createAsyncThunk(
  "pricing/sub-category",
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<SubcategoryResponse>>(
        GET_ALL_SUB_CATEGORIES(id)
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getSecondSubCategoryAction = createAsyncThunk(
  "pricing/second-sub-category",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<SecondSubCategoryResponse>>(
        GET_ALL_SECOND_SUB_CATEGORIES
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getPricing = createAsyncThunk(
  "pricing/all",
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<PricingResponse>>(
        GET_ALL_PRICINGS(id)
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getCategoryRelationship = createAsyncThunk(
  "pricing/category-relationship",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponse<CategoryRelationshipResponse>
      >(GET_CATEGORY_RELATIONSHIP);

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getAlterationSubCategories = createAsyncThunk(
  "pricing/alteration-sub-categories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponse<AlterationSubCategoryResponse>
      >(GET_ALTERATION_SUB_CATEGORIES);

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getFabricTypes = createAsyncThunk(
  "pricing/fabric-types",
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<FabricTypeResponse>>(
        GET_FABRIC_TYPES(id)
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getAlterationPrices = createAsyncThunk(
  "pricing/alteration-prices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<AlterationPriceResponse>>(
        GET_ALL_ALTERATION_PRICE
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getCategoryMaterialRelationship = createAsyncThunk(
  "pricing/category-material-relationship",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponse<CategoryMaterialRelationshipResponse>
      >(GET_CATEGORY_MATERIAL_RELATIONSHIP);

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getSubCategoryMaterialRelationship = createAsyncThunk(
  "pricing/sub-category-material-relationship",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponse<SubCategoryMaterialRelationshipResponse>
      >(GET_SUB_CATEGORY_MATERIAL_RELATIONSHIP);

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

// UPLOAD_PRICE_LIST is my endpoint. request body(form-data) includes only file(type is file)
export const uploadPriceList = createAsyncThunk(
  "pricing/upload-price-list",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post<BaseResponse<any>>(
        UPLOAD_PRICE_LIST,
        formData
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getPriceListAction = createAsyncThunk(
  "price/range",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponseSingle<IPriceResponseBody>>(
        GET_PRICE_LIST(id)
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const reorderCategoriesAction = createAsyncThunk(
  "pricing/reorder-categories",
  async (payload: { categoryId: number }[], { rejectWithValue }) => {
    try {
      const response = await axios.post<BaseResponse<CategoryResponse>>(
        REORDER_CATEGORIES,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const reorderSubCategoriesAction = createAsyncThunk(
  "pricing/reorder-subcategories",
  async (
    payload: { id: number; categoryId: number }[],
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<BaseResponse<SubcategoryResponse>>(
        REORDER_SUB_CATEGORIES,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const createSubcategoryWithImageAction = createAsyncThunk(
  "pricing/create-subcategory-with-image",
  async (
    payload: { name: string; categoryId: number; file: File },
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append("name", payload.name);
      formData.append("categoryId", String(payload.categoryId));
      formData.append("file", payload.file);
      const response = await axios.post<BaseResponse<any>>(
        CREATE_SUBCATEGORY_WITH_IMAGE,
        formData
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const createMaterialAction = createAsyncThunk(
  "pricing/create-material",
  async (
    payload: { name: string; categoryId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<BaseResponse<any>>(
        CREATE_MATERIAL,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const reorderMaterialsAction = createAsyncThunk(
  "pricing/reorder-materials",
  async (payload: { materialId: number }[], { rejectWithValue }) => {
    try {
      const response = await axios.post<BaseResponse<any>>(
        REORDER_MATERIALS,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const createSecondSubcategoryAction = createAsyncThunk(
  "pricing/create-second-subcategory",
  async (
    payload: { name: string; pieceCount: number; categoryId: number; subcategoryId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<BaseResponse<any>>(
        CREATE_SECOND_SUBCATEGORY,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const deleteCategoryAction = createAsyncThunk(
  "pricing/delete-category",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<any>>(DELETE_CATEGORY(id));
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const deleteSubcategoryAction = createAsyncThunk(
  "pricing/delete-subcategory",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<any>>(DELETE_SUBCATEGORY(id));
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const deleteMaterialAction = createAsyncThunk(
  "pricing/delete-material",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<any>>(DELETE_MATERIAL(id));
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const deleteSecondSubcategoryAction = createAsyncThunk(
  "pricing/delete-second-subcategory",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<any>>(DELETE_SECOND_SUBCATEGORY(id));
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const updateCategoryAction = createAsyncThunk(
  "pricing/update-category",
  async (payload: { categoryId: number; categoryName: string }, { rejectWithValue }) => {
    try {
      const response = await axios.put<BaseResponse<any>>(UPDATE_CATEGORY, payload);
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const updateSubcategoryAction = createAsyncThunk(
  "pricing/update-subcategory",
  async (payload: { id: number; name: string; categoryId: number }, { rejectWithValue }) => {
    try {
      const response = await axios.put<BaseResponse<any>>(UPDATE_SUBCATEGORY, payload);
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const updateMaterialAction = createAsyncThunk(
  "pricing/update-material",
  async (payload: { id: number; name: string }, { rejectWithValue }) => {
    try {
      const response = await axios.put<BaseResponse<any>>(UPDATE_MATERIAL(payload.id), { name: payload.name });
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const upsertPriceAction = createAsyncThunk(
  "pricing/upsert-price",
  async (
    payload: { categoryId: number; subCategoryId: number; secondSubCategoryId: number; materialId: number; price: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<BaseResponse<any>>(UPSERT_PRICE, payload);
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const updateSecondSubcategoryAction = createAsyncThunk(
  "pricing/update-second-subcategory",
  async (payload: { sub2Id: number; sub2Name: string; pieceCount: number }, { rejectWithValue }) => {
    try {
      const response = await axios.put<BaseResponse<any>>(UPDATE_SECOND_SUBCATEGORY, payload);
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);

export const reorderSecondSubcategoriesAction = createAsyncThunk(
  "pricing/reorder-second-subcategories",
  async (payload: { id: number }[], { rejectWithValue }) => {
    try {
      const response = await axios.post<BaseResponse<any>>(
        REORDER_SECOND_SUBCATEGORIES,
        payload
      );
      return { response: response.data };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);
